import React, { Component, Fragment } from "react"

import {
  Button,
  Tooltip,
  Tabs,
  Drawer,
  Menu,
  Dropdown,
  Input,
  Select,
  Popover,
} from "antd"

import {
  UploadOutlined,
  DeleteFilled,
  EditFilled,
  DownOutlined,
  LeftOutlined,
  CloseOutlined,
  SlackSquareFilled,
} from "@ant-design/icons"

import { pick, get, has, map, concat, split, filter, isEmpty } from "lodash"

import "./index.less"
import { buttonAction_btns, buttonAction_context } from "../Snowplow/config2"

const SurveyMenu = (props) => {
  return (
    <Menu>
      {!get(props.configSurvey, "template_based", true) && (
        <Menu.Item
          disabled={!!get(props.surveyName, "measures", []).length}
          onClick={() => {
            const { id_survey } = props.surveyName
            props.history.push(`/models/surveys/import/${id_survey}`)
          }}>
          {get(props.surveyName, "measures", []).length ? (
            <Popover
              overlayClassName="disabled-options-survey"
              content="No es posible editar cuestionarios que están siendo usados en mediciones en curso."
              trigger="hover">
              <UploadOutlined /> Importar Nuevas Preguntas
            </Popover>
          ) : (
            <Fragment>
              <UploadOutlined /> Importar Nuevas Preguntas
            </Fragment>
          )}
        </Menu.Item>
      )}
      <Menu.Item
        disabled={false}
        onClick={() => {
          props.downloadSurveyWatcher(props.match.params.id)
          const { id_survey } = props.surveyName
          buttonAction_context("Exportar encuesta", 'id_survey', id_survey)
        }}>

        <Fragment>
          <DownOutlined /> Exportar
        </Fragment>

      </Menu.Item>
      <Menu.Item
        //disabled={!!get(props.surveyName, "measures", []).length}
        onClick={() => {
          const { id_survey_type, id_scope_type, id_survey } = props.surveyName
          props.setStateFrom("modalEditSurvey", true)
          props.setStateFrom("id_survey_type", id_survey_type)
          props.setStateFrom("id_scope_type", id_scope_type)
          buttonAction_context("Editar cuestionario", 'id_survey', id_survey)
          /* this.props.setStateFrom({
            modalEditSurvey: true,
            id_survey_type,
          }) */
        }}>
        <Fragment>
          <EditFilled /> Editar
        </Fragment>
      </Menu.Item>
      <Menu.Item
        disabled={
          !get(props.surveyName, "is_deletable", false) ||
          !!get(props.surveyName, "measures", []).length
        }
        className="color-delete"
        onClick={
          () =>
            props.setStateFrom(
              "modalDeleteAllQuestions",
              true
            ) /* this.setState({ modalDeleteAllQuestions: true }) */
        }>
        {!get(props.surveyName, "is_deletable", false) ||
          !!get(props.surveyName, "measures", []).length ? (
          <Popover
            overlayClassName="disabled-options-survey"
            content="No es posible editar cuestionarios que están siendo usados en mediciones en curso."
            trigger="hover">
            <DeleteFilled /> Eliminar todas las preguntas
          </Popover>
        ) : (
          <Fragment>
            <DeleteFilled /> Eliminar todas las preguntas
          </Fragment>
        )}
      </Menu.Item>
      <Menu.Item
        disabled={
          !get(props.surveyName, "is_deletable", false) ||
          !!get(props.surveyName, "measures", []).length
        }
        className="color-delete"
        onClick={
          () =>
            props.setStateFrom(
              "modalDeleteSurvey",
              true
            ) /* this.setState({ modalDeleteSurvey: true }) */
        }>
        {!get(props.surveyName, "is_deletable", false) ||
          !!get(props.surveyName, "measures", []).length ? (
          <Popover
            overlayClassName="disabled-options-survey"
            content="No es posible editar cuestionarios que están siendo usados en mediciones en curso."
            trigger="hover">
            <DeleteFilled /> Eliminar cuestionario
          </Popover>
        ) : (
          <Fragment>
            <DeleteFilled /> Eliminar cuestionario
          </Fragment>
        )}
      </Menu.Item>
    </Menu>
  )
}

export default SurveyMenu
